module.exports = __webpack_public_path__ + "static/antlers-d42231eed63e927cc3f1448a9c5c230b.jpg";